import { Grid, Hidden } from '@material-ui/core';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useLocation, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useContext, useEffect } from 'react';
import { MainContent } from '../../../../../../global/components/layout/main-content-container';
import { PageContainer } from '../../../../../../global/components/layout/page-container';
import { PageHeader } from '../../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../../global/components/layout/sidebar-content';
import { usePensionEnrollmentInfo } from '../../../pension-enrollment/hooks/usePensionEnrollmentInfo';
import { useEmploymentInfo } from '../../../employment/useEmployment';
import { useDemographicsPerson } from '../../../../../account-info/hooks/useDemographicsPerson';
import { DemographicsContext } from '../../../../../../global/models/demographics-model';
import { useBasePath } from '../../../../../../global/hooks/useBasePath';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { ArcRoutes } from '../../../../constants/routes';
import { EmploymentState } from '../../../employment/employment-model';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { WysiwygWithReactLink } from '../../../../../../global/components/wysiwyg-with-react-link';
import { useGpsType } from '../../../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../../../global/components/guided-process-support-block';
import { PensionEnrollmentForm } from './pension-enrollment-form';
import { apiErrorClear } from '../../../../../../global/ducks/base-api';
import { clearPensionInfo } from '../../../pension-enrollment/pension-enrollment-slice';
import { setCurrentNewHireBenefitEnrollmentStep } from '../../slice/new-hire-enrollment-slices';
import { BenefitEnrollmentStep } from '../../models/pension-enrollment-models';

interface Props {
	basePath: string;
}

export function PensionEnrollment(props: Props) {

	const { basePath } = props;
	const app = useContext(DemographicsContext);
	const personLoaded = useDemographicsPerson(app);
	const pensionInfoLoaded = usePensionEnrollmentInfo();
	const employmentLoaded = useEmploymentInfo();
	const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
	const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
	const location = useLocation();
	const gpsItem = useGpsType(GpsType.NEW_HIRE_RETIREMENT_ADMIN);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.PENSION));
		// clear info when app unmounts
		return function cleanup() {
			dispatch(apiErrorClear());
			dispatch(clearPensionInfo());
		};
	}, []);

	if (!employmentState?.currentEmployee) {

		return (
			<Redirect to=
				{
					{
						pathname: employeeSelect,
						state: {
							actionLink: location.pathname,
						},
					}
				}
			/>);
	}

	if (!pensionInfoLoaded || !personLoaded || !employmentLoaded) {
		return <LoadingCircle />;
	}

    return (
        <PageContainer>
            <MainContent>
                <PageHeader
                    headerText={newHireProps?.retirementEnrollmentTitle}
                    description={newHireProps?.retirementEnrollmentAdminDescription}
                />
                <Hidden mdUp>
                    <SideBarContent>
                        <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                    </SideBarContent>
                </Hidden>
                <PensionEnrollmentForm basePath={basePath} />
                <Grid container direction='row' justifyContent='flex-end'>
                    <Grid
                        justifyContent='flex-end'
                        container
                        item md={6}>
                        <WysiwygWithReactLink content={newHireProps?.continueToCoverageDescriptionText} />
                    </Grid>
                </Grid>

			</MainContent>
			<Hidden smDown>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>
			</Hidden>
		</PageContainer>
	);
}